module.exports = __webpack_public_path__ + "img/success_OLD_3.e800c846.gif";